export var getEdgeNativeSandboxUrl = function (linkTokenPayload, baseUrl, platform) {
    // If we don't have a platform or if we're in production mode, we don't need to append the
    // platform URL params
    if (!platform || !(linkTokenPayload.mode === 'sandbox')) {
        return baseUrl;
    }
    var urlWithParams = new URL(baseUrl);
    // Supplying the edge native Sites dummy endpoint with platformName and platformLogoUrl makes for a better experience
    // because it makes different platforms clearly look different.
    urlWithParams.searchParams.append('platformName', platform.name);
    if (platform.searchLogoUrl) {
        urlWithParams.searchParams.append('platformLogoUrl', platform.searchLogoUrl);
    }
    return urlWithParams.toString();
};
